// eslint-disable-next-line no-unused-vars
import grhtml5 from './grhtml5-6.8-min.js'
// eslint-disable-next-line no-unused-vars
import webapp from './grwebapp.js'

export default {
  // 启动报表工具
  webapp_ws_ajax_run (params) {
    webapp.webapp_ws_ajax_run(params)
  },
  // 生成报表预览
  reportViewer (report, data) {
    if (report) {
      var reportViewer = window.rubylong.grhtml5.insertReportViewer('report_holder')
      reportViewer.reportPrepared = false // 指定报表生成需要加载报表模板
      reportViewer.dataPrepared = false // 指定报表生成需要加载报表数据
      reportViewer.loadReport(report)
      reportViewer.loadData(data)
      reportViewer.start()
      webapp.webapp_urlprotocol_startup()
    }
  },
  // 格式化报表数据
  getReport (formConfig, type, subConfig, flowData, imageList) {
    if (type == 1) {
      return this.getQueryReport(formConfig, 1)
    }
    if (type == 2) {
      return this.getEditReport(formConfig, subConfig, flowData, imageList)
    }
  },
  // 获取表单模板
  getEditReport (formConfig, subConfig, flowData, imageList) {
    let grf = {
      'Version': '6.6.6.2',
      // 'Version': '6.6.8.0',
      'Title': formConfig.title,
      'Font': {
        'Name': '宋体',
        'Size': 90000,
        'Weight': 400,
        'Charset': 134
      },
      'Printer': {
        'LeftMargin': 1.5,
        'TopMargin': 1.5,
        'RightMargin': 1.5,
        'BottomMargin': 1.5
      },
      'Parameter': [],
      'ReportHeader': [],
      'ReportFooter': []
    }
    let Report = {
      'Name': 'ReportHeader2',
      'CanGrow': true,
      'Height': 10,
      'Control': [
        {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Center': 'Horizontal',
          'Left': 7,
          'Top': 0.2,
          'Width': 7,
          'Height': 0.8,
          'Font': {
            'Name': '宋体',
            'Size': 180000,
            'Charset': 134
          },
          'TextAlign': 'MiddleCenter',
          'Text': formConfig.title
        }
      ]
    }
    let before = 1
    let row = 1
    let col = 1
    let wid = 18 / formConfig.colNum
    formConfig.formColumns.forEach(e => {
      if (e && e.widgetType != 'sub-form') {
        if (e.row > before && e.hidden != 1) {
          col = 1
          row++
          before = e.row
        }
        if (e.widgetType === 'divider') {
          let left = 0
          let top = 1.8 + (row - 1) * 1
          col++
          let lable = {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'Left': left,
            'Top': top,
            'Width': 10,
            'WordWrap': true,
            'CanGrow': true,
            'Height': 1,
            'Font': {
              Name: '宋体',
              Size: 120000,
              Charset: 134
            },
            'Text': e.title
          }
          Report.Control.push(lable)
        } else if (e.widgetType != 'divider' && e.hidden != 1) {
          let left = (col - 1) * wid
          let top = 1.8 + (row - 1) * 1
          col += e.col
          let lable1 = {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'Font': {
              Name: '宋体',
              Size: 90000,
              Weight: 400,
              Charset: 134
            },
            'Left': left,
            'Top': top,
            'Width': 2,
            'Height': 1,
            'WordWrap': true,
            // 'CanExpand': true, // 可伸展
            'CanGrow': true,
            // 'Border': {
            //   'Styles': '[DrawLeft|DrawTop|DrawRight|DrawBottom]'
            // },
            'TextAlign': 'MiddleLeft',
            'Text': e.title + '：'
          }
          let lable2 = {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'Font': {
              Name: '宋体',
              Size: 90000,
              Weight: 400,
              Charset: 134
            },
            'Left': left + 2,
            'Top': top,
            'WordWrap': true,
            'CanGrow': true,
            'Width': wid * e.col - 2,
            'TextAlign': 'MiddleLeft',
            // 'Border': {
            //   'Styles': '[DrawLeft|DrawTop|DrawRight|DrawBottom]'
            // },
            'Height': 1,
            'Text': '[#{' + e.columnName + '}#]'
          }
          grf.Parameter.push({ 'Name': e.columnName })
          Report.Control.push(lable1)
          Report.Control.push(lable2)
        }
      }
      Report.Height = 1.8 + row * 1
    })
    if (subConfig) {
      let rep = this.getQueryReport(subConfig.config, 2)
      grf.DetailGrid = rep.DetailGrid
    }
    // 添加logo
    let logo = {
      'Type': 'PictureBox',
      'Name': 'SYS_COMPANY_LOGO',
      'Left': 0,
      'Top': 0,
      'Width': 1,
      'Height': 1,
      'ImageIndex': 0
    }
    Report.Control.push(logo)
    // 判断是否有流程数据
    if (flowData && flowData.length > 0) {
      // 先过滤掉开始节点 节点start为true的节点
      // flowData = flowData.filter(item => {
      //   return !item.start
      // })
      let ReportFooter = {
        'Name': 'ReportFooter1',
        'Height': 2 * flowData.length + 2,
        'Control': [
          {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'TextAlign': 'MiddleCenter',
            'Left': 0,
            'Top': 1,
            'Width': 4,
            'WordWrap': true,
            'CanGrow': true,
            'Height': 1,
            'Border': {
              'Styles': '[DrawLeft|DrawTop]'
            },
            'Font': {
              Name: '宋体',
              Size: 120000,
              Charset: 134
            },
            'Text': '单位/部门'
          },
          {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'TextAlign': 'MiddleCenter',
            'Left': 4,
            'Top': 1,
            'Width': 14,
            'WordWrap': true,
            'CanGrow': true,
            'Border': {
              'Styles': '[DrawLeft|DrawTop|DrawRight]'
            },
            'Height': 1,
            'Font': {
              Name: '宋体',
              Size: 120000,
              Charset: 134
            },
            'Text': '审核意见'
          }
        ]
      }
      let top = 2
      let FooterHeight = 2
      for (let i = 0; i < flowData.length; i++) {
        let item = flowData[i]
        let height = 2
        if (item.comment && (item.comment.length / 135) > 2) {
          height = (item.comment.length / 135) + 0.4
        }
        if (i !== 0) {
          top += height
        }
        FooterHeight += height
        let leftBorder = '[DrawLeft|DrawTop]'
        let rightBorder = '[DrawLeft|DrawTop|DrawRight]'
        // 如果是最后一行
        if (i === flowData.length - 1) {
          leftBorder = '[DrawLeft|DrawTop|DrawBottom]'
          rightBorder = '[DrawLeft|DrawTop|DrawRight|DrawBottom]'
        }
        // 部门
        let depart = {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Font': {
            Name: '宋体',
            Size: 90000,
            Weight: 400,
            Charset: 134
          },
          'Left': 0,
          'Top': top,
          'WordWrap': true,
          'CanGrow': true,
          'Border': {
            'Styles': leftBorder
          },
          'Width': 4,
          'TextAlign': 'MiddleCenter',
          'Height': height,
          'Text': '[#{' + 'wf_' + 'node_' + item.taskDefKey + '}#]'
        }
        grf.Parameter.push({ 'Name': 'wf_' + 'node_' + item.taskDefKey })
        ReportFooter.Control.push(depart)
        // 审批意见
        let comment = {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Font': {
            Name: '宋体',
            Size: 90000,
            Weight: 400,
            Charset: 134
          },
          'Left': 4,
          'Top': top,
          'WordWrap': true,
          'CanGrow': true,
          'Border': {
            'Styles': rightBorder
          },
          'Width': 14,
          'TextAlign': 'TopLeft',
          'Height': height,
          'Text': '[#{' + 'wf_' + 'comment_' + item.taskDefKey + '}#]'
        }
        grf.Parameter.push({ 'Name': 'wf_' + 'comment_' + item.taskDefKey })
        ReportFooter.Control.push(comment)
        if (i === 0) {
          ReportFooter.Control.push({
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'Font': {
              Name: '宋体',
              Size: 90000,
              Weight: 400,
              Charset: 134
            },
            'Left': 10,
            'Top': (top - 0.1),
            'WordWrap': true,
            'CanGrow': true,
            'Width': 2.4,
            'TextAlign': 'BottomLeft',
            'Height': height,
            'Text': '[#{' + 'wf_' + 'assignee_' + item.taskDefKey + '}#]'
          })
        } else {
          // 审批人
          let user = {}
          // 如果有审批人个性签名 则使用个性签名
          if (imageList[i] && imageList[i].Image) {
            ReportFooter.Control.push({
              'Type': 'MemoBox',
              'Name': 'MemoBox1',
              'Font': {
                Name: '宋体',
                Size: 90000,
                Weight: 400,
                Charset: 134
              },
              'Left': 10,
              'Top': (top - 0.1),
              'WordWrap': true,
              'CanGrow': true,
              'Width': 1.2,
              'TextAlign': 'BottomLeft',
              'Height': height,
              'Text': '审批人:'
            })
            user = {
              'Type': 'PictureBox',
              'Name': 'wf_sign_' + item.taskDefKey,
              'Left': 11.2,
              'Top': (top + 0.9),
              'Width': 1.2,
              'Height': 1,
              'Alignment': 'BottomLeft',
              'ImageIndex': i + 1
            }
          } else {
            user = {
              'Type': 'MemoBox',
              'Name': 'MemoBox1',
              'Font': {
                Name: '宋体',
                Size: 90000,
                Weight: 400,
                Charset: 134
              },
              'Left': 10,
              'Top': (top - 0.1),
              'WordWrap': true,
              'CanGrow': true,
              'Width': 4,
              'TextAlign': 'BottomLeft',
              'Height': height,
              'Text': '审批人：[#{' + 'wf_' + 'assignee_' + item.taskDefKey + '}#]'
            }
          }
          ReportFooter.Control.push(user)
        }
        grf.Parameter.push({ 'Name': 'wf_' + 'assignee_' + item.taskDefKey })
        // 日期
        let time = {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Font': {
            Name: '宋体',
            Size: 90000,
            Weight: 400,
            Charset: 134
          },
          'Left': 13,
          'Top': (top - 0.1),
          'WordWrap': true,
          'CanGrow': true,
          'Width': 5,
          'TextAlign': 'BottomLeft',
          'Height': height,
          'Text': '时间：[#{' + 'wf_' + 'endTime_' + item.taskDefKey + '}#]'
        }
        grf.Parameter.push({ 'Name': 'wf_' + 'endTime_' + item.taskDefKey })
        ReportFooter.Control.push(time)
      }
      ReportFooter.Height = FooterHeight
      grf.ReportFooter.push(ReportFooter)
    }

    grf.ReportHeader.push(Report)
    console.log(JSON.stringify(grf))
    return grf
  },
  getEditReport2 (formConfig, subList,wfData, signData,vm) {
    let grf = {
      'Version': '6.6.6.2',
      'Title': formConfig.title,
      'Font': {
        'Name': '宋体',
        'Size': 90000,
        "Bold":false,
        "Weight":0,
        'Charset': 134
      },
      // "InitializeScript":"Report.Utility.TextWrapByWord = false;",
      'Printer': {
        'LeftMargin': 1.5,
        'TopMargin': 1.5,
        'RightMargin': 1.5,
        'BottomMargin': 1.5
      },
      'Parameter': [],
      'ReportHeader': [],
      'ReportFooter': []
    }
    let reportHeaderTitle = {
      'Name': 'ReportHeader1',
      'CanGrow': true,
      'Height': 1.2,
      'Control': [
        {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Center': 'Horizontal',
          'Left': 7,
          'Top': 0.2,
          'Width': 18,
          'Height': 1.2,
          'Font': {
            'Name': '宋体',
            "Size":180000,
            "Weight":400,
            "Charset":134
          },
          'TextAlign': 'MiddleCenter',
          'Text': formConfig.title
        }
      ]
    }

    let before = 1
    // 因为每个字段其实是占用两列，一列是标题，一列是值
    let cols = formConfig.colNum
    let row = 0
    let col = 1
    let standardWith = 17.96
    let columnTitleWidth = standardWith/cols/3
    let columnValueWidth = standardWith/cols/3*2
    let freeColumnCount = cols*2
    let freeGridColumn = []
    let freeGridRow = []
    let freeGridCell = []
    let cellHeight = 0.95
    let parameter = []
    for(let i = 0; i<cols;i++){
      freeGridColumn.push({
        "index": (i*2+1),
        "Width": columnTitleWidth
      })
      freeGridColumn.push({
        "index": (i*2+2),
        "Width": (i === cols-1)?(columnValueWidth):columnValueWidth
      })
      /*
      freeGridRow.push({
        "index": (i*2+2),
        "Height": cellHeight
      })*/
    }
    let formColumns = {}
    let rowNum = 1
    // 避免排序不对，先做个排序
    formConfig.formColumns.forEach(c => {
      if (c && c.widgetType !== 'sub-form'
        && c.widgetType !== 'divider'
        ) {
        let hidden = false
        if(vm){
          hidden = vm.formColumnHidden(c);
        }else if(c.hidden && c.hidden === 1){
          hidden = true;
        }
        // console.log(c.columnName+'--hidden---'+hidden);
        if(!hidden){
          if(!formColumns[c.row]){
            formColumns[c.row] = []
          }
          formColumns[c.row].push(c)
          if(c.row>rowNum){
            rowNum = c.row
          }
        }

      }
    })
    for(let rowIndex = 1;rowIndex<=rowNum;rowIndex++){
      let rowArray = formColumns[rowIndex]
      if(rowArray){
        row++
        col = 1

        freeGridRow.push({
          "index": row,
          "Height": cellHeight
        })

        rowArray.forEach(c => {
          parameter.push({"Name": c.columnName})
          let titleCell = {
            "row": row,
            "col": col,
            "WordWrap":true,
            "CanGrow":true,
            "Font":{
              "Name":"宋体",
              "Size":90000,
              // "Bold":true,
              'Weight': 400,
              "Charset":134
            },
            "TextAlign": "MiddleCenter",
            "Text": c.title,
            "BorderCustom":false
          }
          col++
          let colSpan = (1 + (c.col - 1)*2)
          let valueCell = null
          if(c.widgetType && c.widgetType === 'full-editor'){
            valueCell = {
              "row": row,
              "col": col,
              "FreeCell":true,
              "CanShrink":true,
              "WordWrap":true,
              "CanGrow":true,
              "Control":[
                {
                  "Type":"MemoBox",
                  "Name":c.columnName,
                  "PaddingBottom":5,
                  "Dock":"Fill",
                  "HtmlTags":true,
                  "WordWrap":true,
                  "CanGrow":true,
                  "CanShrink":true,
                  "Text":"[#{"+c.columnName+"}#]"
                }
              ],
              "ColSpan": colSpan
            }
          }else if(c.widgetType && c.widgetType === 'explain'){
            valueCell = {
              "row": row,
              "col": col,
              "FreeCell":true,
              "CanShrink":true,
              "WordWrap":true,
              "CanGrow":true,
              "Control":[
                {
                  "Type":"MemoBox",
                  "Name":c.columnName,
                  "PaddingBottom":5,
                  "Dock":"Fill",
                  "HtmlTags":true,
                  "WordWrap":true,
                  "CanGrow":true,
                  "CanShrink":true,
                  "Text": c.attr
                }
              ],
              "ColSpan": colSpan
            }
          }else{
            valueCell = {
              "row": row,
              "col": col,
              "WordWrap":true,
              "CanGrow":true,
              "CanShrink":true,
              "Text":"[#{"+c.columnName+"}#]",
              "ColSpan": colSpan
            }
          }
          col = col + colSpan
          freeGridCell.push(titleCell)
          freeGridCell.push(valueCell)
        })
      }

    }
    let freeGrid = {
      "Type":"FreeGrid",
      "Name":"FreeGrid1",
      "Top":0,
      "Border":{
        "Styles":"[DrawLeft|DrawTop|DrawRight|DrawBottom]",
        "InnerIndent":1
      },
      "ColumnCount":freeColumnCount,
      "RowCount":row,
      "FreeGridColumn": freeGridColumn,
      "FreeGridRow": freeGridRow,
      "FreeGridCell": freeGridCell
    }
    let reportHeader2 = {
      "Name":"ReportHeader2",
      "CanGrow":true,
      "Height":row*0.95+0.04,
      "Control":[freeGrid]
    }

    // grf.ReportHeader.push(reportHeaderTitle,reportHeader2)
    grf.ReportHeader.push(reportHeaderTitle,reportHeader2)
    // grf.ReportHeader.push(reportHeaderTitle)
    let headerIndex = 2;
    // 渲染明细表
    if(subList){
      subList.forEach((sub,index) => {
        let subJson = this.getQueryReport(sub.config, 2)

        let subReportHeader = {
          "Name":"ReportHeader"+(headerIndex++),
          "CanGrow":true,
          "Height":1.5875,
          "Control":[{
              "Type": "SubReport",
              "Name": "SubReport"+(index+1),
              "Dock": "Fill",
              "Report": subJson
            }]
        }
        // console.log('---subReportHeader---',subReportHeader)
        grf.ReportHeader.push(subReportHeader)
      })
    }
    if(wfData && wfData.length>0){
      let wfReportHeader = this.getWfReport3(headerIndex,wfData, signData)

      grf.ReportHeader.push(wfReportHeader)
    }

    grf.Parameter = parameter
    // console.log('-----',subList,grf)
    return grf
  },
  getWfReport3(headerIndex,wfData, signData){
    console.log('-----getWfReport3-----',wfData, signData)
    // 渲染流程数据
    let wfFreeGridCell = [{
      "row":1,
      "col":1,
      "Font":{
        "Name":"宋体",
        "Size":90000,
        "Bold":true,
        "Charset":134
      },
      "TextAlign":"MiddleCenter",
      "Text":"部门/单位",
      "BorderCustom":true
    },
      {
        "row":1,
        "col":2,
        "Font":{
          "Name":"宋体",
          "Size":90000,
          "Bold":true,
          "Charset":134
        },
        "TextAlign":"MiddleCenter",
        "Text":"审核意见",
        "BorderCustom":true,
        "ColSpan":6}]
    let freeGridRow =[
      {
        "index":1,
        "Height":1
      }
    ]
    let height = 1
    let rowIndex = 1
    // wfData = [wfData[0]]
    wfData.forEach((node,index) =>{
      if(!node.children){
        node.children = [node]
      }
      // console.log('-----node-----',node.children)
      node.children.forEach(c => {
        rowIndex++

        freeGridRow.push(
          {
            "index":rowIndex,
            "Height":1.0
          },{
            "index":rowIndex+1,
            "Height":1
          })
        height+= 2

        let signCell = null
        // console.log(c.sign+'--------',signData[c.sign])
        // 判断是否有签名
        if( c.sign && signData[c.sign]){
          signCell = {
            "row":rowIndex+1,
            "col":5,
            "FreeCell":true,
            "BorderCustom":true,
            // "CanGrow":true,
            "Border":{
              "Styles":"[DrawBottom]"
            },
            "TextAlign":"MiddleLeft",
            "Control":[
              {
                "Type":"PictureBox",
                "Name":"Photo"+rowIndex,
                // "Center":"Vertical",
                "Center":"Both",
                // "Left":0.3,
                // "Top":0.01,
                // "Width":1.5,
                // "Height":0.5,
                // "SizeMode":"EnsureFullView",
                "Dock": "Fill",
                "Picture": signData[c.sign]
              }
            ]
          }
        }else{
          signCell = {
            "row":rowIndex+1,
            "col":5,
            "TextAlign":"MiddleLeft",
            "CanGrow":true,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            },
            "Text": c.assignee

          }
        }

        // console.log('-----c-----',c.endTime)
        let row = [
          {
            "row":rowIndex,
            "col":1,
            "TextAlign":"MiddleCenter",
            "Text":node.name,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom|DrawRight]"
            },
            "RowSpan":2
          },
          {
            "row":rowIndex,
            "col":2,
            "WordWrap":true,
            "TextAlign":"TopLeft",
            "CanGrow":true,
            "Text": c.comment,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawRight]"
            },
            "ColSpan":6
          },
          {
            "row":(++rowIndex),
            "col":2,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            },
            "TextAlign":"MiddleRight",
            "Text":"部门："
          },
          {
            "row":rowIndex,
            "col":3,
            "TextAlign":"MiddleLeft",
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            },
            "Text": c.departName
          },
          {
            "row":rowIndex,
            "col":4,
            "TextAlign":"MiddleRight",
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            },
            "Text": node.start?'申请人：':"审批人："
          },
          signCell,
          {
            "row":rowIndex,
            "col":6,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            },
            "TextAlign":"MiddleRight",
            "Text":"时间："
          },
          {
            "row":rowIndex,
            "col":7,
            "ColSpan":1,
            "Text": c.endTime,
            "BorderCustom":true,
            /*"Border":{
              "Styles":"[DrawBottom]"
            },*/
            "TextAlign":"MiddleLeft"
          }/*,
          {
            "row":rowIndex,
            "col":8,
            "Text": '',
            "BorderCustom":true,
            "TextAlign":"MiddleLeft"
          }*/
        ]
        // console.log('----------'+row);
        wfFreeGridCell = wfFreeGridCell.concat(row)
      })
    })

    let wfReportHeader = {
      "Name":"ReportHeader"+(headerIndex++),
      "KeepTogether":false, // 是否保存同页，默认是，设置之后如果超过一页会另起一行
      "CanGrow":true,
      // "Height":1.0+1.8*rowIndex,
      "Height":height,
      "Control":[{
        "Type":"FreeGrid",
        "Name":"FreeGrid2",
        //"Dock":"Fill",
        "Border":{
          "Styles":"[DrawLeft]"
        },
        "Width":18-0.05,
        "ColumnCount":7,
        "RowCount":rowIndex,
        "FreeGridColumn":[
          {
            "index":1,
            "Width":3
          },{
            "index":2,
            "Width":1.5
          },{
            "index":3,
            "Width":3
          },
          {
            "index":4,
            "Width":1.5
          },
          {
            "index":5,
            "Width":2.5
          },
          {
            "index":6,
            "Width":1.5
          },
          {
            "index":7,
            "Width":4.95
          }
         /* ,
          {
            "index":8,
            "Width":0.5
          }*/
        ],
        "FreeGridRow":freeGridRow,
        "FreeGridCell":wfFreeGridCell
      }]
    }
    return wfReportHeader
  },
  getWfReport2(headerIndex,wfData, signData){
    console.log('-----getWfReport2-----',wfData, signData)
    // 渲染流程数据
    let wfFreeGridCell = [{
      "row":1,
      "col":1,
      "Font":{
        "Name":"宋体",
        "Size":90000,
        "Bold":true,
        "Charset":134
      },
      "TextAlign":"MiddleCenter",
      "Text":"部门/单位",
      "BorderCustom":true
    },
      {
        "row":1,
        "col":2,
        "Font":{
          "Name":"宋体",
          "Size":90000,
          "Bold":true,
          "Charset":134
        },
        "TextAlign":"MiddleCenter",
        "Text":"审核意见",
        "BorderCustom":true,
        "ColSpan":5}]
    let freeGridRow =[
      {
        "index":1,
        "Height":0.8
      }
    ]
    let height = 0.8
    let rowIndex = 1
    // wfData = [wfData[0],wfData[0],wfData[0]]
    wfData.forEach((node,index) =>{
      if(!node.children){
        node.children = [node]
      }
      node.children.forEach(c => {
        rowIndex++

        freeGridRow.push(
          {
            "index":rowIndex,
            "Height":1.0
          },{
            "index":rowIndex+1,
            "Height":0.8
          })
        height+= 1.8

        let signCell = null
        // console.log(c.sign+'--------',signData[c.sign])
        // 判断是否有签名
        if(c.sign && signData[c.sign]){
          signCell = {
            "row":rowIndex+1,
            "col":4,
            "FreeCell":true,
            "Control":[
              {
                "Type":"PictureBox",
                "Name":"Photo1",
                "Center":"Vertical",
                "Left":0.0,
                "Top":0.5,
                "Width":2,
                "Height":1.0,
                "Picture": signData[c.sign],
                "SizeMode":"EnsureFullView"
              }
            ],
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            }
          }
        }else{
          signCell = {
            "row":rowIndex+1,
            "col":4,
            "TextAlign":"MiddleLeft",
            "CanGrow":true,
            "Text": c.assignee,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            }
          }
        }

        let row = [
          {
            "row":rowIndex,
            "col":1,
            "TextAlign":"MiddleCenter",
            "Text":node.name,
            "RowSpan":2
          },
          {
            "row":rowIndex,
            "col":2,
            "WordWrap":true,
            "TextAlign":"TopLeft",
            "CanGrow":true,
            "Text": c.comment,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawRight]"
            },
            "ColSpan":5
          },
          {
            "row":(++rowIndex),
            "col":2,
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            }
          },
          {
            "row":rowIndex,
            "col":3,
            "TextAlign":"MiddleRight",
            "Text": node.start?'申请人：':"审批人：",
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            }
          },
          signCell,
          {
            "row":rowIndex,
            "col":5,
            "TextAlign":"MiddleRight",
            "Text":"时间：",
            "BorderCustom":true,
            "Border":{
              "Styles":"[DrawBottom]"
            }
          },
          {
            "row":rowIndex,
            "col":6,
            "Text": c.endTime,
            "BorderCustom":true
          }
        ]
        wfFreeGridCell = wfFreeGridCell.concat(row)
      })
    })

    let wfReportHeader = {
      "Name":"ReportHeader"+(headerIndex++),
      "CanGrow":true,
      // "Height":1.0+1.8*rowIndex,
      "Height":height,
      "Control":[{
        "Type":"FreeGrid",
        "Name":"FreeGrid2",
        "Dock":"Fill",
        "Border":{
          "Styles":"[DrawLeft|DrawBottom]"
        },
        "ColumnCount":6,
        "RowCount":rowIndex,
        "FreeGridColumn":[
          {
            "index":1,
            "Width":3
          },{
            "index":2,
            "Width":3
          },{
            "index":3,
            "Width":2
          },
          {
            "index":4,
            "Width":4
          },
          {
            "index":5,
            "Width":2
          },
          {
            "index":6,
            "Width":4
          }
        ],
        "FreeGridRow":freeGridRow,
        "FreeGridCell":wfFreeGridCell
      }]
    }
    return wfReportHeader
  },
  getWfRepoft (flowData, imageList) {
    let ReportFooter = null
    let Parameter = []
    if (flowData && flowData.length > 0) {
      // 先过滤掉开始节点 节点start为true的节点
      // flowData = flowData.filter(item => {
      //   return !item.start
      // })
      ReportFooter = {
        'Name': 'ReportFooter1',
        'Height': 2 * flowData.length + 2,
        'Control': [
          {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'TextAlign': 'MiddleCenter',
            'Left': 0,
            'Top': 1,
            'Width': 4,
            'WordWrap': true,
            'CanGrow': true,
            'Height': 1,
            'Border': {
              'Styles': '[DrawLeft|DrawTop]'
            },
            'Font': {
              Name: '宋体',
              Size: 120000,
              Charset: 134
            },
            'Text': '单位/部门'
          },
          {
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'TextAlign': 'MiddleCenter',
            'Left': 4,
            'Top': 1,
            'Width': 14,
            'WordWrap': true,
            'CanGrow': true,
            'Border': {
              'Styles': '[DrawLeft|DrawTop|DrawRight]'
            },
            'Height': 1,
            'Font': {
              Name: '宋体',
              Size: 120000,
              Charset: 134
            },
            'Text': '审核意见'
          }
        ]
      }
      let top = 2
      let FooterHeight = 2
      for (let i = 0; i < flowData.length; i++) {
        let item = flowData[i]
        let height = 2
        if (item.comment && (item.comment.length / 135) > 2) {
          height = (item.comment.length / 135) + 0.4
        }
        if (i !== 0) {
          top += height
        }
        FooterHeight += height
        let leftBorder = '[DrawLeft|DrawTop]'
        let rightBorder = '[DrawLeft|DrawTop|DrawRight]'
        // 如果是最后一行
        if (i === flowData.length - 1) {
          leftBorder = '[DrawLeft|DrawTop|DrawBottom]'
          rightBorder = '[DrawLeft|DrawTop|DrawRight|DrawBottom]'
        }
        // 部门
        let depart = {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Font': {
            Name: '宋体',
            Size: 90000,
            Weight: 400,
            Charset: 134
          },
          'Left': 0,
          'Top': top,
          'WordWrap': true,
          'CanGrow': true,
          'Border': {
            'Styles': leftBorder
          },
          'Width': 4,
          'TextAlign': 'MiddleCenter',
          'Height': height,
          'Text': '[#{wf_node_' + item.taskDefKey + '}#]'
        }
        Parameter.push({ 'Name': 'wf_' + 'node_' + item.taskDefKey })
        ReportFooter.Control.push(depart)
        // 审批意见
        let comment = {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Font': {
            Name: '宋体',
            Size: 90000,
            Weight: 400,
            Charset: 134
          },
          'Left': 4,
          'Top': top,
          'WordWrap': true,
          'CanGrow': true,
          'Border': {
            'Styles': rightBorder
          },
          'Width': 14,
          'TextAlign': 'TopLeft',
          'Height': height,
          'Text': '[#{' + 'wf_' + 'comment_' + item.taskDefKey + '}#]'
        }
        Parameter.push({ 'Name': 'wf_' + 'comment_' + item.taskDefKey })
        ReportFooter.Control.push(comment)
        if (i === 0) {
          ReportFooter.Control.push({
            'Type': 'MemoBox',
            'Name': 'MemoBox1',
            'Font': {
              Name: '宋体',
              Size: 90000,
              Weight: 400,
              Charset: 134
            },
            'Left': 10,
            'Top': (top - 0.1),
            'WordWrap': true,
            'CanGrow': true,
            'Width': 1.2,
            'TextAlign': 'BottomLeft',
            'Height': height,
            'Text': '[#{' + 'wf_' + 'assignee_' + item.taskDefKey + '}#]发起了审批'
          })
        } else {
          // 审批人
          let user = {}
          // 如果有审批人个性签名 则使用个性签名
          if (imageList[i] && imageList[i].Image) {
            ReportFooter.Control.push({
              'Type': 'MemoBox',
              'Name': 'MemoBox1',
              'Font': {
                Name: '宋体',
                Size: 90000,
                Weight: 400,
                Charset: 134
              },
              'Left': 10,
              'Top': (top - 0.1),
              'WordWrap': true,
              'CanGrow': true,
              'Width': 1.2,
              'TextAlign': 'BottomLeft',
              'Height': height,
              'Text': '审批人:'
            })
            user = {
              'Type': 'PictureBox',
              'Name': 'wf_sign_' + item.taskDefKey,
              'Left': 11.2,
              'Top': (top + 0.9),
              'Width': 1.2,
              'Height': 1,
              'Alignment': 'BottomLeft',
              'ImageIndex': i + 1
            }
          } else {
            user = {
              'Type': 'MemoBox',
              'Name': 'MemoBox1',
              'Font': {
                Name: '宋体',
                Size: 90000,
                Weight: 400,
                Charset: 134
              },
              'Left': 10,
              'Top': (top - 0.1),
              'WordWrap': true,
              'CanGrow': true,
              'Width': 4,
              'TextAlign': 'BottomLeft',
              'Height': height,
              'Text': '审批人：[#{' + 'wf_' + 'assignee_' + item.taskDefKey + '}#]'
            }
          }
          ReportFooter.Control.push(user)
        }
        Parameter.push({ 'Name': 'wf_' + 'assignee_' + item.taskDefKey })
        // 日期
        let time = {
          'Type': 'MemoBox',
          'Name': 'MemoBox1',
          'Font': {
            Name: '宋体',
            Size: 90000,
            Weight: 400,
            Charset: 134
          },
          'Left': 13,
          'Top': (top - 0.1),
          'WordWrap': true,
          'CanGrow': true,
          'Width': 5,
          'TextAlign': 'BottomLeft',
          'Height': height,
          'Text': '时间：[#{' + 'wf_' + 'endTime_' + item.taskDefKey + '}#]'
        }
        Parameter.push({ 'Name': 'wf_' + 'endTime_' + item.taskDefKey })
        ReportFooter.Control.push(time)
      }
      ReportFooter.Height = FooterHeight
    }
    return {
      ReportFooter: ReportFooter,
      Parameter: Parameter
    }
  },
  // 处理生成多表头格式
  handMoreColumns (fields) {
    // 处理多表头
    let fieldsmap = []
    // 遍历所有字段组织多表头的数据位
    for (let i = 0; i < fields.length; i++) {
      let title = fields[i].title
      // System.out.println("1===" + title + "==");
      if (title.indexOf('-') > -1) {
        let titles = title.split('-')
        let length = titles.length
        let j = length
        if (fieldsmap.find(event => { return event.title === titles[0] })) {
          let temp = fieldsmap.find(event => { return event.title === titles[0] })
          let k = 1
          for (k = 1; k < length - 1; k++) {
            if (temp.children.find(event => { return event.title === titles[k] })) {
              temp = temp.children.find(event => { return event.title === titles[k] })
            } else {
              for (let m = k; m < length - 1; m++) {
                if (!temp.children) {
                  temp.children = []
                }
                temp.children.push({title: titles[m], children: [] })
                temp = temp.find(event => { return event.title === titles[m] })
              }
              break
            }
          }
          if (!temp.children) {
            temp.children = []
          }
          fields[i].title = titles[length - 1]
          temp.children.push(fields[i])
        } else {
          fieldsmap.push({title: titles[0], children: [] })
          let temp = fieldsmap.find(event => { return event.title === titles[0] })
          for (let k = 1; k < length - 1; k++) {
            if (!temp.children) {
              temp.children = []
            }
            temp.children.push({title: titles[k], children: [] })
            temp = temp.children.find(event => { return event.title === titles[k] })
          }
          if (!temp.children) {
            temp.children = []
          }
          fields[i].title = titles[length - 1]
          temp.children.push(fields[i])
        }
      } else {
        fieldsmap.push(fields[i])
      }
    }
    return fieldsmap
  },
  getCellWidth(column,width,totalWidth,type,lastColumn,sumWidth,maxWidth){
    let resultWidth;
    if (type === 1) {
      resultWidth = ((width || 100) / maxWidth * 28).toFixed(1)
    } else {
      resultWidth = ((width || 100) / maxWidth * 18).toFixed(1)
    }
    let resultWidthArr = resultWidth.split('.')
    let num1 = Number(resultWidthArr[0])
    let num2 = Number(resultWidthArr[1])
    let result = 0.5;
    // 判断是否最后一列
    if(column.columnName == lastColumn.columnName){
      result =  (totalWidth-sumWidth);
    }else{
      if(num2>7){
        result =  (num1+1)
      }else if(num2>5){
        result =  (num1+0.5)
      }else if(num2==5){
        result =  Number(resultWidth)
      }else if(num2>2){
        result =  (num1+0.5)
      }else{
        result =  (num1)
      }
    }
    // console.log(column.columnName+'------'+resultWidth+'-------',num1,num2,result,maxWidth,totalWidth)
    return result;
  },
  // 获取查询模板(简单表头)
  getQueryReport2(params, type) {
    // type=1 查询，2 明细表
    var grf = {
      'Version': '6.6.6.2',
      'Title': params.title,
      'Font': {
        'Name': '宋体',
        'Size': 90000,
        'Weight': 400,
        'Charset': 134
      },
      "PrintAsDesignPaper": type===2?false:true,
      'Printer': type === 2 ? {} : {
        'LeftMargin': 1.5,
        'TopMargin': 1.5,
        'RightMargin': 1.5,
        'BottomMargin': 1.5
      },
      'DetailGrid': {
        'Recordset': {
          'Field': []
        },
        'Column': [],
        'ColumnContent': {
          'Height': 0.65,
          'Font': {
            'Name': '宋体',
            'Size': 90000,
            'Weight': 400,
            'Charset': 134
          },
          'AdjustRowHeight': false,
          'ColumnContentCell': []
        },
        'ColumnTitle': {
          'Height': 0.8,
          'Font': {
            'Name': '宋体',
            'Size': 90000,
            'Weight': 400,
            'Charset': 134
          },
          'RepeatStyle': 'None',
          'ColumnTitleCell': []
        }
      },
      'ReportHeader': []
    }
    if(type == 1){
      grf.ReportHeader = [
        {
          'Height': 1,
          'Control': [
            {
              'Type': 'StaticBox',
              'Name': 'StaticBox1',
              'Center': 'Horizontal',
              'Left': 7,
              'Top': 0.18,
              'Width': 7,
              'Height': 0.6,
              'Font': {
                'Name': '宋体',
                'Size': 150000,
                'Bold': true,
                'Charset': 134
              },
              'Text': params.title,
              'TextAlign': 'MiddleCenter'
            },
            {
              'Type': 'PictureBox',
              'Name': 'SYS_COMPANY_LOGO',
              'Left': 0,
              'Top': 0,
              'Width': 1,
              'Height': 1,
              'ImageIndex': 0
            }
          ]
        }
      ]
    }else{
      grf.ReportHeader = [{
        "Name":"ReportHeader1",
        "Height":0.8,
        "Control":[
          {
            "Type":"StaticBox",
            "Name":"StaticBox2",
            "BackStyle":"Normal",
            "Dock":"Fill",
            "Border":{
              "Styles":"[DrawLeft|DrawRight]"
            },
            "Font":{
              "Name":"宋体",
              "Size":105000,
              "Bold":true,
              "Charset":134
            },
            "TextAlign":"MiddleCenter",
            "Text": params.title,
          }
        ]
      }]
    }
    let totalWidth = 18;
    let maxWidth = 0
    let lastColumn = null
    params.queryColumns.forEach(e => {
      if (e.javaType !== 'TopButton' && e.widgetType !== 'sub-form' && e.hidden !== 1) {
        if (e.width) {
          maxWidth += parseInt(e.width)
        } else {
          maxWidth += 100
        }
        lastColumn = e;
      }
    })
    // console.log('---11111----',lastColumn.title)
    let summaryList = []
    let left = 0
    let queryColumns = this.handMoreColumns(JSON.parse(JSON.stringify(params.queryColumns)))
    let moreColumns = 1
    let sumWidth = 0;
    // 如果有流程
    if (params.ifHasProcess && params.ifHasProcess === 1) {
      grf.DetailGrid.Recordset.Field.push({'Name': 'PROC_STATUS_'})
      let column = {'Name': 'PROC_STATUS_'}
      if (type === 1) {
        grf.Printer.Oriention = 'Landscape'
        column.Width = 100 / maxWidth * 28
      } else {
        column.Width = 100 / maxWidth * 18
      }
      let ColumnContent = {'Column': 'PROC_STATUS_', 'DataField': 'PROC_STATUS_', 'WordWrap': true, 'CanGrow': true}
      ColumnContent.TextAlign = 'MiddleCenter'
      grf.DetailGrid.Column.push(column)
      grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
      let columnTitleCell = {'GroupTitle': false, 'Column': 'PROC_STATUS_', 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': '审批状态'}
      columnTitleCell.TextAlign = 'MiddleCenter'
      grf.DetailGrid.ColumnTitle.ColumnTitleCell.push(columnTitleCell)
      left += 100
      sumWidth += column.Width
    }
    queryColumns.forEach(e => {
      if (e.javaType !== 'TopButton'  && e.widgetType !== 'sub-form' && e.hidden !== 1) {
        if (e.columnName) {
          grf.DetailGrid.Recordset.Field.push({'Name': e.columnName})
          let dataAlign = 'MiddleCenter'
          if (e.dataAlign === 'left') {
            dataAlign = 'MiddleLeft'
          } else if (e.dataAlign === 'right') {
            dataAlign = 'MiddleRight'
          }
          let column = {'Name': e.columnName}
          let ColumnContent = {'Column': e.columnName, 'DataField': e.columnName,"CanShrink":true, 'WordWrap': true, 'CanGrow': true}
          if (type === 1) {
            grf.Printer.Oriention = 'Landscape'
            column.Width = (e.width || 100) / maxWidth * 28
          } else {
            column.Width = this.getCellWidth(e,e.width,totalWidth,type,lastColumn,sumWidth,maxWidth);//(e.width || 100) / maxWidth * 18
          }
          if (dataAlign) {
            ColumnContent.TextAlign = dataAlign
          }
          if (e.summary === 1) {
            e.TextAlign = ColumnContent.TextAlign
            e.Left = left
            e.Width = column.Width
            summaryList.push(e)
          }
          left += column.Width
          sumWidth += column.Width
          grf.DetailGrid.Column.push(column)
          grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
          let columnTitleCell = {'GroupTitle': false, 'Column': e.columnName, 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': e.title}
          let titleAlign = 'MiddleCenter'
          // 标题居中
          // if (e.titleAlign === 'left') {
          //   titleAlign = 'MiddleLeft'
          // } else if (e.titleAlign === 'right') {
          //   titleAlign = 'MiddleRight'
          // }
          if (titleAlign) {
            columnTitleCell.TextAlign = titleAlign
          }
          grf.DetailGrid.ColumnTitle.ColumnTitleCell.push(columnTitleCell)
        } else {
          // 第二层
          if (e.children && e.children.length > 0) {
            moreColumns = 2
            let columnTitleCell = {'GroupTitle': true, 'ColumnTitleCell': [], 'Name': e.title, 'BackColor': 'FFFFFF', 'Text': e.title, 'TextAlign': 'MiddleCenter'}
            e.children.forEach(e1 => {
              if (e1.columnName) {
                grf.DetailGrid.Recordset.Field.push({'Name': e1.columnName})
                let dataAlign = 'MiddleCenter'
                if (e1.dataAlign === 'left') {
                  dataAlign = 'MiddleLeft'
                } else if (e1.dataAlign === 'right') {
                  dataAlign = 'MiddleRight'
                }
                let column = {'Name': e1.columnName}
                let ColumnContent = {'Column': e1.columnName, 'DataField': e1.columnName, 'WordWrap': true, 'CanGrow': true}
                if (type === 1) {
                  grf.Printer.Oriention = 'Landscape'
                  column.Width =(e1.width || 100) / maxWidth * 28
                } else {
                  column.Width = (e1.width || 100) / maxWidth * 18
                }
                if (dataAlign) {
                  ColumnContent.TextAlign = dataAlign
                }
                if (e1.summary === 1) {
                  e1.TextAlign = ColumnContent.TextAlign
                  e1.Left = left
                  e1.Width = column.Width
                  summaryList.push(e1)
                }
                left += column.Width
                sumWidth += column.Width
                grf.DetailGrid.Column.push(column)
                grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
                let columnTitleCell1 = {'GroupTitle': false, 'Column': e1.columnName, 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': e1.title}
                let titleAlign = 'MiddleCenter'
                if (titleAlign) {
                  columnTitleCell1.TextAlign = titleAlign
                }
                columnTitleCell.ColumnTitleCell.push(columnTitleCell1)
              } else {
                if (e1.children && e1.children.length > 0) {
                  moreColumns = 3
                  let columnTitleCell1 = {'GroupTitle': true, 'ColumnTitleCell': [], 'Name': e1.title, 'BackColor': 'FFFFFF', 'Text': e1.title, 'TextAlign': 'MiddleCenter'}
                  e1.children.forEach(e2 => {
                    if (e2.columnName) {
                      grf.DetailGrid.Recordset.Field.push({'Name': e2.columnName})
                      let dataAlign = 'MiddleCenter'
                      if (e2.dataAlign === 'left') {
                        dataAlign = 'MiddleLeft'
                      } else if (e2.dataAlign === 'right') {
                        dataAlign = 'MiddleRight'
                      }
                      let column = {'Name': e2.columnName}
                      let ColumnContent = {'Column': e2.columnName, 'DataField': e2.columnName, 'WordWrap': true, 'CanGrow': true}
                      if (type === 1) {
                        grf.Printer.Oriention = 'Landscape'
                        column.Width = (e1.width || 100) / maxWidth * 28
                      } else {
                        column.Width = (e1.width || 100) / maxWidth * 18
                      }
                      if (dataAlign) {
                        ColumnContent.TextAlign = dataAlign
                      }
                      if (e2.summary === 1) {
                        e2.TextAlign = ColumnContent.TextAlign
                        e2.Left = left
                        e2.Width = column.Width
                        summaryList.push(e2)
                      }
                      left += column.Width
                      sumWidth += column.Width
                      grf.DetailGrid.Column.push(column)
                      grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
                      let columnTitleCell2 = {'GroupTitle': false, 'Column': e2.columnName, 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': e2.title}
                      let titleAlign = 'MiddleCenter'
                      if (titleAlign) {
                        columnTitleCell2.TextAlign = titleAlign
                      }
                      columnTitleCell1.ColumnTitleCell.push(columnTitleCell2)
                    }
                  })
                  columnTitleCell.ColumnTitleCell.push(columnTitleCell1)
                }
              }
            })
            grf.DetailGrid.ColumnTitle.ColumnTitleCell.push(columnTitleCell)
          }
        }
      }
    })
    grf.DetailGrid.ColumnTitle.Height = (moreColumns > 1) ? 0.6 * moreColumns : 0.8 * moreColumns

    // console.log('----sumWidth----'+sumWidth)
    if (summaryList.length > 0) {
      let Group = [
        {
          'Name': 'Group1',
          'GroupHeader': {
            'Height': 0
          },
          'GroupFooter': {
            'Height': 0.8,
            'Control': [
              {
                'Type': 'MemoBox',
                'Name': 'MemoBox10',
                'AlignColumn': grf.DetailGrid.Column[0].Name,
                'Height': 0.8,
                'Border': {
                  'Styles': '[DrawRight]'
                },
                'Font': {
                  'Name': '宋体',
                  'Size': 90000,
                  'Bold': true,
                  'Charset': 134
                },
                'TextAlign': 'MiddleCenter',
                'Text': '合计'
              }
            ]
          }
        }
      ]
      for (let index = 0; index < summaryList.length; index++) {
        const e = summaryList[index]
        let Item = {
          Type: 'MemoBox',
          Name: 'MemoBox' + (11 + index),
          AlignColumn: e.columnName,
          Left: e.Left,
          Width: e.Width,
          Height: 0.8,
          Border: {
            Styles: '[DrawLeft|DrawRight]'
          },
          Font: {
            Name: '宋体',
            Size: 90000,
            Bold: 'T',
            Charset: 134
          },
          TextAlign: e.TextAlign,
          Text: '[#Sum(' + e.columnName + '):#]'
        }
        Group[0].GroupFooter.Control.push(Item)
      }
      grf.DetailGrid.Group = Group
    }
    return grf
  },
  getQueryReport (params, type) {
    // type=1 查询，2 明细表
    var grf = {
      'Version': '6.6.6.2',
      'Title': params.title,
      'Font': {
        'Name': '宋体',
        'Size': 90000,
        'Weight': 400,
        'Charset': 134
      },
      "PrintAsDesignPaper": type===2?false:true,
      'Printer': type === 2 ? {} : {
        'LeftMargin': 1.5,
        'TopMargin': 1.5,
        'RightMargin': 1.5,
        'BottomMargin': 1.5
      },
      'DetailGrid': {
        'Recordset': {
          'Field': []
        },
        'Column': [],
        'ColumnContent': {
          'Height': 0.65,
          'Font': {
            'Name': '宋体',
            'Size': 90000,
            'Weight': 400,
            'Charset': 134
          },
          'AdjustRowHeight': false,
          'ColumnContentCell': []
        },
        'ColumnTitle': {
          'Height': 0.8,
          'Font': {
            'Name': '宋体',
            'Size': 90000,
            'Weight': 400,
            'Charset': 134
          },
          'RepeatStyle': 'None',
          'ColumnTitleCell': []
        }
      },
      'ReportHeader': []
    }
    if(type == 1){
      grf.ReportHeader = [
        {
          'Height': 1,
          'Control': [
            {
              'Type': 'StaticBox',
              'Name': 'StaticBox1',
              'Center': 'Horizontal',
              'Left': 7,
              'Top': 0.18,
              'Width': 7,
              'Height': 0.6,
              'Font': {
                'Name': '宋体',
                'Size': 150000,
                'Bold': true,
                'Charset': 134
              },
              'Text': params.title,
              'TextAlign': 'MiddleCenter'
            },
            {
              'Type': 'PictureBox',
              'Name': 'SYS_COMPANY_LOGO',
              'Left': 0,
              'Top': 0,
              'Width': 1,
              'Height': 1,
              'ImageIndex': 0
            }
          ]
        }
      ]
    }else{
      grf.ReportHeader = [{
        "Name":"ReportHeader1",
        "Height":0.8,
        "Control":[
          {
            "Type":"StaticBox",
            "Name":"StaticBox2",
            "BackStyle":"Normal",
            "Dock":"Fill",
            "Border":{
              "Styles":"[DrawLeft|DrawRight]"
            },
            "Font":{
              "Name":"宋体",
              "Size":105000,
              "Bold":true,
              "Charset":134
            },
            "TextAlign":"MiddleCenter",
            "Text": params.title,
          }
        ]
      }]
    }
    let maxWidth = 0
    let lastColumn = null
    params.queryColumns.forEach(e => {
      if (e.javaType !== 'TopButton' && e.javaType!== 'CellButton' && e.widgetType !== 'sub-form' && e.hidden !== 1) {
        if (e.width) {
          maxWidth += parseInt(e.width)
        } else {
          maxWidth += 100
        }
        lastColumn = e;
      }
    })
    // console.log('---11111----',lastColumn.title)
    let summaryList = []
    let left = 0
    let queryColumns = this.handMoreColumns(JSON.parse(JSON.stringify(params.queryColumns)))
    let moreColumns = 1
    let sumWidth = 0;
    // 如果有流程
    if (params.ifHasProcess && params.ifHasProcess === 1) {
      grf.DetailGrid.Recordset.Field.push({'Name': 'PROC_STATUS_'})
      let column = {'Name': 'PROC_STATUS_'}
      if (type === 1) {
        grf.Printer.Oriention = 'Landscape'
        column.Width = 100 / maxWidth * 28
      } else {
        column.Width = 100 / maxWidth * 18
      }
      let ColumnContent = {'Column': 'PROC_STATUS_', 'DataField': 'PROC_STATUS_', 'WordWrap': true, 'CanGrow': true}
      ColumnContent.TextAlign = 'MiddleCenter'
      grf.DetailGrid.Column.push(column)
      grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
      let columnTitleCell = {'GroupTitle': false, 'Column': 'PROC_STATUS_', 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': '审批状态'}
      columnTitleCell.TextAlign = 'MiddleCenter'
      grf.DetailGrid.ColumnTitle.ColumnTitleCell.push(columnTitleCell)
      left += 100
      sumWidth += column.Width
    }
    queryColumns.forEach(e => {
      //console.log(e.title+'------',e,e.javaType !== 'TopButton' )
      if (e.javaType !== 'TopButton' && e.javaType !== 'CellButton' && e.widgetType !== 'sub-form' && e.hidden !== 1) {
        //console.log('--------222---------')
        if (e.columnName) {
          grf.DetailGrid.Recordset.Field.push({'Name': e.columnName})
          let dataAlign = 'MiddleCenter'
          if (e.dataAlign === 'left') {
            dataAlign = 'MiddleLeft'
          } else if (e.dataAlign === 'right') {
            dataAlign = 'MiddleRight'
          }
          let column = {'Name': e.columnName}
          let ColumnContent = {'Column': e.columnName, 'DataField': e.columnName,"CanShrink":true, 'WordWrap': true, 'CanGrow': true}
          if (type === 1) {
            grf.Printer.Oriention = 'Landscape'
            column.Width = (e.width || 100) / maxWidth * 28
          } else {
            column.Width = (e.width || 100) / maxWidth * 18
          }
          // console.log(e.title+'------------------',dataAlign,e.dataAlign,e)
          if (dataAlign) {
            ColumnContent.TextAlign = dataAlign
          }
          if (e.summary === 1) {
            e.TextAlign = ColumnContent.TextAlign
            e.Left = left
            e.Width = column.Width
            summaryList.push(e)
          }
          left += column.Width
          sumWidth += column.Width
          grf.DetailGrid.Column.push(column)
          grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
          let columnTitleCell = {'GroupTitle': false, 'Column': e.columnName, 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': e.title}
          let titleAlign = 'MiddleCenter'
          // 标题居中
          // if (e.titleAlign === 'left') {
          //   titleAlign = 'MiddleLeft'
          // } else if (e.titleAlign === 'right') {
          //   titleAlign = 'MiddleRight'
          // }
          if (titleAlign) {
            columnTitleCell.TextAlign = titleAlign
          }
          grf.DetailGrid.ColumnTitle.ColumnTitleCell.push(columnTitleCell)
        } else {
          // 第二层
          if (e.children && e.children.length > 0) {
            moreColumns = 2
            let columnTitleCell = {'GroupTitle': true, 'ColumnTitleCell': [], 'Name': e.title, 'BackColor': 'FFFFFF', 'Text': e.title, 'TextAlign': 'MiddleCenter'}
            e.children.forEach(e1 => {
              if (e1.columnName) {
                grf.DetailGrid.Recordset.Field.push({'Name': e1.columnName})
                let dataAlign = 'MiddleCenter'
                if (e1.dataAlign === 'left') {
                  dataAlign = 'MiddleLeft'
                } else if (e1.dataAlign === 'right') {
                  dataAlign = 'MiddleRight'
                }
                let column = {'Name': e1.columnName}
                let ColumnContent = {'Column': e1.columnName, 'DataField': e1.columnName, 'WordWrap': true, 'CanGrow': true}
                if (type === 1) {
                  grf.Printer.Oriention = 'Landscape'
                  column.Width =(e1.width || 100) / maxWidth * 28
                } else {
                  column.Width = (e1.width || 100) / maxWidth * 18
                }
                if (dataAlign) {
                  ColumnContent.TextAlign = dataAlign
                }
                if (e1.summary === 1) {
                  e1.TextAlign = ColumnContent.TextAlign
                  e1.Left = left
                  e1.Width = column.Width
                  summaryList.push(e1)
                }
                left += column.Width
                sumWidth += column.Width
                grf.DetailGrid.Column.push(column)
                grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
                let columnTitleCell1 = {'GroupTitle': false, 'Column': e1.columnName, 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': e1.title}
                let titleAlign = 'MiddleCenter'
                if (titleAlign) {
                  columnTitleCell1.TextAlign = titleAlign
                }
                columnTitleCell.ColumnTitleCell.push(columnTitleCell1)
              } else {
                if (e1.children && e1.children.length > 0) {
                  moreColumns = 3
                  let columnTitleCell1 = {'GroupTitle': true, 'ColumnTitleCell': [], 'Name': e1.title, 'BackColor': 'FFFFFF', 'Text': e1.title, 'TextAlign': 'MiddleCenter'}
                  e1.children.forEach(e2 => {
                    if (e2.columnName) {
                      grf.DetailGrid.Recordset.Field.push({'Name': e2.columnName})
                      let dataAlign = 'MiddleCenter'
                      if (e2.dataAlign === 'left') {
                        dataAlign = 'MiddleLeft'
                      } else if (e2.dataAlign === 'right') {
                        dataAlign = 'MiddleRight'
                      }
                      let column = {'Name': e2.columnName}
                      let ColumnContent = {'Column': e2.columnName, 'DataField': e2.columnName, 'WordWrap': true, 'CanGrow': true}
                      if (type === 1) {
                        grf.Printer.Oriention = 'Landscape'
                        column.Width = (e1.width || 100) / maxWidth * 28
                      } else {
                        column.Width = (e1.width || 100) / maxWidth * 18
                      }
                      if (dataAlign) {
                        ColumnContent.TextAlign = dataAlign
                      }
                      if (e2.summary === 1) {
                        e2.TextAlign = ColumnContent.TextAlign
                        e2.Left = left
                        e2.Width = column.Width
                        summaryList.push(e2)
                      }
                      left += column.Width
                      sumWidth += column.Width
                      grf.DetailGrid.Column.push(column)
                      grf.DetailGrid.ColumnContent.ColumnContentCell.push(ColumnContent)
                      let columnTitleCell2 = {'GroupTitle': false, 'Column': e2.columnName, 'WordWrap': true, 'CanGrow': true, 'BackColor': 'FFFFFF', 'Text': e2.title}
                      let titleAlign = 'MiddleCenter'
                      if (titleAlign) {
                        columnTitleCell2.TextAlign = titleAlign
                      }
                      columnTitleCell1.ColumnTitleCell.push(columnTitleCell2)
                    }
                  })
                  columnTitleCell.ColumnTitleCell.push(columnTitleCell1)
                }
              }
            })
            grf.DetailGrid.ColumnTitle.ColumnTitleCell.push(columnTitleCell)
          }
        }
      }
    })
    grf.DetailGrid.ColumnTitle.Height = (moreColumns > 1) ? 0.6 * moreColumns : 0.8 * moreColumns

    // console.log('----sumWidth----'+sumWidth)
    if (summaryList.length > 0) {
      let Group = [
        {
          'Name': 'Group1',
          'GroupHeader': {
            'Height': 0
          },
          'GroupFooter': {
            'Height': 0.8,
            'Control': [
              {
                'Type': 'MemoBox',
                'Name': 'MemoBox10',
                'AlignColumn': grf.DetailGrid.Column[0].Name,
                'Height': 0.8,
                'Border': {
                  'Styles': '[DrawRight]'
                },
                'Font': {
                  'Name': '宋体',
                  'Size': 90000,
                  'Bold': true,
                  'Charset': 134
                },
                'TextAlign': 'MiddleCenter',
                'Text': '合计'
              }
            ]
          }
        }
      ]
      for (let index = 0; index < summaryList.length; index++) {
        const e = summaryList[index]
        let Item = {
          Type: 'MemoBox',
          Name: 'MemoBox' + (11 + index),
          AlignColumn: e.columnName,
          Left: e.Left,
          Width: e.Width,
          Height: 0.8,
          Border: {
            Styles: '[DrawLeft|DrawRight]'
          },
          Font: {
            Name: '宋体',
            Size: 90000,
            Bold: 'T',
            Charset: 134
          }, 'WordWrap': true, 'CanGrow': true,

          TextAlign: e.TextAlign,
          Text: '[#Sum(' + e.columnName + '):0.00#]'
        }
        Group[0].GroupFooter.Control.push(Item)
      }
      grf.DetailGrid.Group = Group
    }
    return grf
  },
  getSubData (params) {
    let subData = []
    params.formColumns.forEach(e => {
      if (e.widgetType === 'sub-form') {
        if (e.config.tableData) {
          e.config.tableData.forEach(ele => {
            subData.push(ele)
          })
        }
      }
    })
    return subData
  },
  // 获取总行数
  getRowCount (formColumns) {
    let col = 0
    formColumns.forEach(e => {
      if (e && e.widgetType != 'sub-form' && e.row > col) {
        col = e.row
      }
    })
    return col
  }
}



// WEBPACK FOOTER //
// ./src/sys/report/utils.js